// extracted by mini-css-extract-plugin
module.exports = {"multiLineTruncate":"TruncatingTextWithTooltip_multiLineTruncate__3GCO3","singleLineTruncate":"TruncatingTextWithTooltip_singleLineTruncate__2Kbxm"};